import { endpoints } from "../endpoints";
import type { AssetContainerType } from "./assetContainer.types";

export type ActivityTargetType = AssetContainerType | "template";

type ActivityQueryParams = {
  offset: number;
  limit: number;
  order_by?: "asc" | "desc";
  sort_by?: string;
};

export function getActivityListEndpoint(
  targetType: ActivityTargetType,
  tenantId: string,
  targetId: string
): string {
  switch (targetType) {
    case "product":
    case "template":
      return endpoints.v2_storefronts_id_pim_actvities(tenantId);
    case "customer":
      return endpoints.v2_tenants_id_customers_id_activities(
        tenantId,
        targetId
      );
    case "supplier":
      return endpoints.v2_tenants_id_suppliers_id_activities(
        tenantId,
        targetId
      );
    case "distributor":
      return endpoints.v2_tenants_id_distributors_id_activities(
        tenantId,
        targetId
      );
  }
}

export function getActivityListParams(
  targetType: ActivityTargetType,
  targetId: string,
  query: ActivityQueryParams
) {
  const baseParams = {
    offset: query.offset,
    limit: query.limit,
    ...(query.order_by ? { order_by: query.order_by } : {}),
    ...(query.sort_by ? { sort_by: query.sort_by } : {}),
  };

  switch (targetType) {
    case "template":
      return { ...baseParams, template_id: targetId };
    case "product":
      return { ...baseParams, product_id: targetId };
    case "customer":
    case "supplier":
    case "distributor":
      return baseParams;
  }
}
